import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'on-create-expense-page',
    templateUrl: './create-expense-page.component.html',
    styleUrls: ['./create-expense-page.component.scss'],
})
export class CreateExpensePageComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
